import { useState } from 'react';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H4 from 'UIComponents/elements/headings/H4';
import UISideNav from 'UIComponents/nav/UISideNav';
import { GREAT_WHITE } from 'HubStyleTokens/colors';
import TranslateTemplateNavItem from './TranslateTemplateNavItem';
import TranslateTemplateNavbarSection from './TranslateTemplateNavbarSection';
import TranslateTemplateFooterSection from './TranslateTemplateFooterSection';
import TranslateTemplateHeaderSection from './TranslateTemplateHeaderSection';
import TranslateTemplateSupportFormSection from './TranslateTemplateSupportFormSection';
import LanguageSelect from '../../LanguageSelect';
import { selectPrimaryLanguage } from '../../../knowledge-base/selectors/knowledgeBaseDetails';
import { useAppSelector } from '../../../utils/hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledSideNav = styled(UISideNav).withConfig({
  displayName: "TranslateTemplateSideNav__StyledSideNav",
  componentId: "sc-1y5rp5v-0"
})(["border-bottom:1px solid ", ";"], GREAT_WHITE);
const SideNavWrapper = styled.div.withConfig({
  displayName: "TranslateTemplateSideNav__SideNavWrapper",
  componentId: "sc-1y5rp5v-1"
})(["height:100vh;overflow-y:scroll;"]);
const PreviewLanguageSelectWrapper = styled.div.withConfig({
  displayName: "TranslateTemplateSideNav__PreviewLanguageSelectWrapper",
  componentId: "sc-1y5rp5v-2"
})(["font-size:16px;"]);
export default function TranslateTemplateSideNav(props) {
  const [selectedSection, setSelectedSection] = useState(null);
  const masterLanguage = useAppSelector(selectPrimaryLanguage);
  const masterLanguageTranslations = props.values.get(masterLanguage);
  const hasMasterLanguageSupportFormId = !!masterLanguageTranslations.supportFormId;
  const onBackClick = () => setSelectedSection(null);
  return /*#__PURE__*/_jsxs(SideNavWrapper, {
    children: [selectedSection === null && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("div", {
        className: "p-y-9 p-x-4",
        children: [/*#__PURE__*/_jsx(H4, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.templateEditor.translateModal.header"
          })
        }), /*#__PURE__*/_jsxs(PreviewLanguageSelectWrapper, {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.templateEditor.translateModal.previewLanguageSelectPrefix"
          }), /*#__PURE__*/_jsx(LanguageSelect
          // @ts-expect-error ts-migrate(2322) FIXME: Type '{ buttonUse: string; value: any; onChange: (... Remove this comment to see the full error message
          , {
            buttonUse: "transparent",
            value: props.previewLanguage,
            onChange: e => props.onPreviewLanguageChange(e.target.value),
            validLanguages: props.languages
          })]
        })]
      }), /*#__PURE__*/_jsxs(StyledSideNav, {
        children: [/*#__PURE__*/_jsx(TranslateTemplateNavItem
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '"NAV"' is not assignable to para... Remove this comment to see the full error message
        , {
          onClick: () => setSelectedSection('NAV'),
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.templateEditor.translateModal.sections.nav.header"
          })
        }), /*#__PURE__*/_jsx(TranslateTemplateNavItem
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '"HEADER"' is not assignable to p... Remove this comment to see the full error message
        , {
          onClick: () => setSelectedSection('HEADER'),
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.templateEditor.translateModal.sections.header.header"
          })
        }), /*#__PURE__*/_jsx(TranslateTemplateNavItem
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '"FOOTER"' is not assignable to p... Remove this comment to see the full error message
        , {
          onClick: () => setSelectedSection('FOOTER'),
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.templateEditor.translateModal.sections.footer.header"
          })
        }), hasMasterLanguageSupportFormId && /*#__PURE__*/_jsx(TranslateTemplateNavItem
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '"SUPPORT_FORM"' is not assignabl... Remove this comment to see the full error message
        , {
          onClick: () => setSelectedSection('SUPPORT_FORM'),
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.templateEditor.translateModal.sections.supportForm.header"
          })
        })]
      })]
    }), selectedSection === 'NAV' && /*#__PURE__*/_jsx(TranslateTemplateNavbarSection, {
      onBackClick: onBackClick,
      values: props.values,
      languages: props.languages,
      onFieldChange: props.onFieldChange
    }), selectedSection === 'HEADER' && /*#__PURE__*/_jsx(TranslateTemplateHeaderSection, {
      onBackClick: onBackClick,
      values: props.values,
      languages: props.languages,
      onFieldChange: props.onFieldChange
    }), selectedSection === 'FOOTER' && /*#__PURE__*/_jsx(TranslateTemplateFooterSection, {
      onBackClick: onBackClick,
      values: props.values,
      languages: props.languages,
      onFieldChange: props.onFieldChange,
      onSocialLinksFieldChange: props.onSocialLinksFieldChange,
      onFooterLinkFieldChange: props.onFooterLinkFieldChange
    }), selectedSection === 'SUPPORT_FORM' && /*#__PURE__*/_jsx(TranslateTemplateSupportFormSection, {
      onBackClick: onBackClick,
      values: props.values,
      languages: props.languages,
      onFieldChange: props.onFieldChange
    })]
  });
}